import type { BusVehicleTypeListParams, BusVehicleTypeMutation } from "../types";

export const busVehicleTypeQueryKey = ["bus_vehicle_type"] as const;
export const busVehicleTypeDefaults: BusVehicleTypeListParams = {
  page: 1, pageSize: 20, sortField: "sort_no", sortDirection: "asc",
};
export const emptyBusVehicleType: BusVehicleTypeMutation = {
  name: "", seatCount: Number.NaN, sortNo: 0, isDisabled: false,
};
